// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
var __webpack_exports__ = __webpack_require__("../public_html/wp/wp-content/themes/asahi-21/_src/js/jquery.smooth-scroll.js");
